import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const NavLinks = ({ path, children, isMobile = false, onClick }) => {
  const baseClasses =
    "relative font-medium tracking-wide transition-colors duration-200";
  const mobileClasses = "block py-2 text-base w-full text-center";
  const desktopClasses = "px-4 py-2 hover:text-gold";

  const classes = isMobile
    ? `${baseClasses} ${mobileClasses}`
    : `${baseClasses} ${desktopClasses}`;

  return (
    <motion.div
      whileHover={!isMobile ? { scale: 1.05 } : undefined}
      whileTap={{ scale: 0.95 }}
      className={classes}
      onClick={onClick}
    >
      <Link to={path}>{children}</Link>
      {!isMobile && (
        <motion.span
          className="absolute bottom-0 left-0 w-full h-0.5 bg-gold"
          initial={{ width: 0 }}
          whileHover={{ width: "100%" }}
          transition={{ duration: 0.2 }}
        />
      )}
    </motion.div>
  );
};

export default NavLinks;
